var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DemandTable',{attrs:{"zones":_vm.zones,"protections":_vm.protections,"reducedVegetationPerZone":_vm.reducedVegetationPerZone,"reducedSprayMixPerZone":_vm.reducedSprayMixPerZone}})
}
var staticRenderFns = []

export { render, staticRenderFns }